export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";